import React, { useEffect, useState } from 'react';
import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import convert from 'react-from-dom';
var loader = new THREE.ObjectLoader();
var objLoader = new OBJLoader()
//THREE.crossOrigin = 'anonymous'

class WebglPlayer extends React.Component {
  constructor(props) {
    super();
    this.container = null;
    this.camera = null;
    this.scene = null;
    this.renderer = null;
    this.group = null;
    this.object = null;
    this.textures = [];
    this.materials = {}
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerWidth <= 768 ? window.innerHeight * .6 : window.innerHeight;
    console.log(window.innerHeight, this.innerHeight)
    this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    this.renderer.setClearColor(0xffffff, 0);
    this.renderer.setPixelRatio(1);
    this.renderer.setSize(this.innerWidth, this.innerHeight);
    this.renderer.shadowMap.enabled = true;
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0xcce0ff);
    this.scene.fog = new THREE.Fog(0xcce0ff, 1, 1000);

    this.group = new THREE.Object3D();
    this.scene.add(this.group);

    var groundTexture = new THREE.TextureLoader().load('textures/grasslight-big.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(500, 500);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;
    this.groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    //this.groundMaterial.side = THREE.DoubleSide
    var mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(500, 500), this.groundMaterial);
    mesh.position.y = - 2;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    this.scene.add(mesh);

    props.data.lights.map(light => {
      this.scene.add(loader.parseObject(light));
    })
    //
    this.state = { questions: props.questions, stepValue: 0 }

  }
  queTexture = (texture) => {
    if (!this.currentlyLoadingTexture) {
      this.textures.push(texture)
    } else {
      this.loadNextTexture(texture)
    }
  }
  loadNextTexture = (child) => {
    //this.loadedTextures
    let textureLoader = new THREE.TextureLoader();
    textureLoader.load(child.texture, (texture) => {
      child.material.map = texture;
      child.material.needsUpdate = true;
      this.startLoadingTextures()
    })
  }
  startLoadingTextures = () => {
    console.log(this.textures)
    if (this.textures.length) {
      this.loadNextTexture(this.textures.pop())
    }
  }
  componentDidMount = () => {
    this.container.appendChild(this.renderer.domElement);
    this.camera = this.createCamera(loader.parse(this.props.data.camera));
    //this.camera = new THREE.PerspectiveCamera(50, this.innerWidth  / this.innerHeight, 1, 12000);
    //this.camera.position.set(1000, 50, 1500);
    var controls = new OrbitControls(this.camera, this.renderer.domElement);
    //controls.maxPolarAngle = Math.PI * 0.50;
    //controls.minDistance = 30;
    controls.maxDistance = 40;
    controls.panSpeed = 0.5;
    controls.rotateSpeed = 0.5;
    objLoader.setPath('');
    objLoader.load(this.props.data.model.src, (data) => {
      // data.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -1, 0, 1]
      let ignoreMesh = this.props.data.ignore_mesh;
      let configurables = [...new Set(this.props.data.configurables.map(select => select.options.map(option => {
        return [option.hide, option.show, option.mesh].flat().filter(item => item !== undefined)
      }).flat()).flat())]
      data.traverse((child) => {
        if (child instanceof THREE.Mesh) {
          if (ignoreMesh.find(item => item === child.name) === undefined) {
            //do we have it in settings
            var texture = this.props.data.textures[child.name];
            var path = `${child.name}/${child.name}`
            if (texture) path = `${texture}/${texture}`
            //console.log(child.name)
            let material;
            if (this.materials[path]) {
              material = this.materials[path];
            } else {
              material = new THREE.MeshPhongMaterial();
              material.map = new THREE.TextureLoader().load(`textures/${path}.png`);
              this.materials[path] = material;
            }
            //material.aoMap = new THREE.TextureLoader().load(`textures/${path}_AO.png`)
            //material.normalMap = new THREE.TextureLoader().load(`textures/${path}_NORM.png`)
            let mesh = new THREE.Mesh(child.geometry, material);
            //mesh.receiveShadow = true;
            // mesh.castShadow = true;
            this.group.add(mesh);
            let isConfigurable = configurables.find(item => item === child.name)
            if (isConfigurable) {
              mesh.name = child.name
              mesh.visible = false;
            }
          }
        }
      });
      this.object = this.group;
      //this.object.position.z =- 1
      //this.object.position.z = 10
      this.object.position.y = this.props.data.model.position.y
      this.props.data.configurables.map((select, index) => {
        select.selected = 0;
        this.updateModel(select, 0)
      })
    });

    this.renderer.setAnimationLoop(this.animate);
    window.addEventListener('resize', () => this.onWindowResize())
  }
  updateModel = (select, value) => {
    let option = select.options[value];
    if (option.hide) option.hide.map(child => this.group.children.filter(mesh => mesh.name === child).map(a => a.visible = false))
    if (option.show) option.show.map(child => this.group.children.filter(mesh => mesh.name === child).map(a => a.visible = true))
    this.renderer.render(this.scene, this.camera);
  }
  createCamera = (value) => {
    this.camera = value;
    this.camera.aspect = this.innerWidth / this.innerHeight;
    this.camera.updateProjectionMatrix();
    return this.camera;
  }
  animate = () => { this.renderer.render(this.scene, this.camera); }
  onWindowResize = () => {
    this.camera.aspect = this.innerWidth / this.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.innerWidth, this.innerHeight);
  }
  render = () => {
    const { lightbox } = this.state;
    return (
      <div style={{ width: window.innerWidth, height: window.innerHeight }}>
        <div className={'configurable'}>
          <div className={'model-wrapper'}>
            <div style={{ width: "100%", height: "100%" }} ref={thisNode => this.container = thisNode}>
            </div>
          </div>
          <div className={'product-title'}>
            <img src={'assets/icons/logo.png'} alt='logo' />
          </div>
          <div className={'option-wrapper'}>
            <div className={'configurable-container'}>
              <div className={'configurable-header'}>
                <img style={{ width: 24 }} src="assets/icons/white_prev.png" /><span>Back to products</span>
              </div>
              <div className={'configurable-wrapper'}>
                <div className={'configurable-size'}>
                  <div className={'configurable-title'}><span>Select size</span></div>
                  <div className={'configurable-select'}>
                    {this.props.data.sizes.map((size, sizeIndex) => <div key={sizeIndex}>
                      <input type="radio" name={`size`} id={`size${sizeIndex}`} value="size3" />
                      <label htmlFor={`size${sizeIndex}`}>{size.label}</label>
                    </div>)}
                  </div>
                </div>
                <Configurables configurables={this.props.data.configurables} onUpdateConfigurables={this.updateModel} config={this.props.config} />
                <div className={'extra-options'} style={{ padding: 12 }}>
                  <SimpleButton label={'Gallery'} onClick={() => window.open('https://grandgazebos.com.au/gallery/', "_blank")} />
                  <SimpleButton label={'Specifications'} onClick={() => this.setState({ lightbox: true })} />
                  <SimpleButton label={'Quote'} />
                </div>
              </div>
            </div>
          </div>
          <div className={'option-wrapper mobile'}>
            <div className={'extra-options mobile'}>
              <SimpleIconButton showLabel={false} data={{ label: 'back' }} icon='assets/icons/back.svg' onChange={() => console.log('back')} />
              <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                <SimpleIconButton showLabel={false} icon='assets/icons/gallery.svg' onChange={() => window.open('https://grandgazebos.com.au/gallery/', "_blank")} />
                <SimpleIconButton showLabel={false} icon='assets/icons/doc.svg' onClick={() => this.setState({ lightbox: true })} />
                <SimpleIconButton showLabel={false} icon='assets/icons/quote.svg' />
              </div>
            </div>
            <div className={'configurable-container'}>
              <div className={'configurable-wrapper'}>
                <div className={'configurable-size'}>
                  <div className={'configurable-title'}>Select size</div>
                  <div className={'configurable-select'}>
                    {this.props.data.sizes.map((size, sizeIndex) => <div key={sizeIndex}>
                      <input type="radio" name={`size`} id={`size${sizeIndex}`} value="size3" />
                      <label htmlFor={`size${sizeIndex}`}>{size.label}</label>
                    </div>)}
                  </div>
                </div>
                <Configurables configurables={this.props.data.configurables} onUpdateConfigurables={this.updateModel} config={this.props.config} />
              </div>
            </div>
          </div>

          <div className="user-note">
            <ul>
              <li><SVG src="assets/icons/panning.svg" /> Right Click to Pan</li>
              <li><SVG src="assets/icons/rotate.svg" /> Left Click to Rotate</li>
              <li><SVG src="assets/icons/zoom.svg" /> Scroll to zoom in or out</li>
            </ul>
          </div>
          {lightbox ? <LightBox onClose={() => this.setState({ lightbox: false })} images={this.props.data.specs}></LightBox> : null}
        </div>
      </div>
    )
  }
}

const Configurables = ({ configurables, config, onUpdateConfigurables }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    configurables.map((select, index) => {
      select.selected = select.selected = 0;
    })
    setItems(JSON.parse(JSON.stringify(configurables)))
  }, [configurables])
  const onChange = (itemIndex, index) => {
    items[itemIndex].selected = index;
    if (items[itemIndex].options[index].config_id == 5) {
      items.map(item => {
        if (item.selected === 2) {
          item.selected = 0;
        }
      })
    } else if (items[itemIndex].options[index].reset) {
      items[itemIndex].options[index].reset.map(i => items[i].selected = 0)
    }
    setItems(JSON.parse(JSON.stringify(items)));
    onUpdateConfigurables(items[itemIndex], index)
  }
  return <div className="configurable-options">
    {items.map((item, itemIndex) => <SimpleCustomSelect verticalOptions={items.length === 1} key={itemIndex} data={item} onChange={(index) => onChange(itemIndex, index)} config={config} />)}
  </div>
}

const SimpleCustomSelect = ({ verticalOptions, data, onChange, config }) => {
  return (
    <div>
      {!verticalOptions ?
        <div className={'configurable-title'}>
          {data.label}
          {data.note ? <div className={'configurable-note'}><i>{data.note}</i></div> : null}
        </div>
        :
        null
      }

      <div className={'configurable-select'} style={verticalOptions ? { flexDirection: 'column' } : {}}>
        {data.options.map((option, index) => <SimpleIconButton
          style={{ paddingBottom: verticalOptions ? 8 : 0 }}
          showLabel={verticalOptions}
          key={index}
          data={option}
          icon={config.options.find(item => item.id === option.config_id)?.icon || null}
          selected={data.selected === index}
          onClick={() => onChange(index)}
        />)}
      </div>

    </div>
  )
}

const SimpleIconButton = ({ data, showLabel, selected, icon, onClick, style }) => {
  return (
    <div className={`config-option ${selected ? 'selected' : null}`} style={style} onClick={onClick}>
      <div style={showLabel ? { marginRight: 8 } : {}}><SVG src={icon} /></div>
      {showLabel ? <span>{data.label}</span> : null}
    </div>
  )
}

const SVG = ({ src }) => {
  const [svg, setSVG] = useState(null)
  useEffect(() => {
    fetch(src).then(response => response.text()).then(text => setSVG(text))
  }, [src])
  return svg ? convert(svg) : null
}

const SimpleButton = ({ label, onClick }) => <div className={'simple-button'} onClick={onClick}>{label}</div>

const LightBox = ({ images, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onSelectIndex = (index) => {
    setSelectedIndex(index >= 0 ? (index < images.length ? index : images.length - 1) : 0);
  }
  return <div className={'lightbox'} >
    <div>
      <div className={'lightbox-image-wrapper'}>
        <div className={'lightbox-image'}>
          <img src={images[selectedIndex]} />
        </div>
        <div className={'lightbox-thumb-wrapper'}>
          {images.map((image, index) => <div onClick={(e) => { onSelectIndex(index) }} className={'lightbox-thumb'} style={selectedIndex === index ? { borderColor: '#6e3214' } : null}><img src={image} /></div>)}
        </div>
      </div>
      <div className={'lightbox-close'}>
        <div onClick={onClose} className={'btn'} style={{}}>
          <svg height='24px' width='24px' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ><g><path fill-rule="evenodd" d="M50.003,61.176l20.715,21.206c2.078,2.145,3.429,2.166,5.546,0l4.156-4.256   c2.035-2.084,2.174-3.451,0-5.678L58.49,50l21.931-22.449c2.055-2.109,2.094-3.533,0-5.68l-4.156-4.254   c-2.156-2.207-3.488-2.105-5.546,0L50.003,38.824L29.289,17.617c-2.059-2.105-3.391-2.207-5.547,0l-4.154,4.254   c-2.096,2.146-2.059,3.57,0,5.68L41.517,50L19.588,72.448c-2.174,2.227-2.059,3.594,0,5.678l4.154,4.256   c2.098,2.166,3.449,2.145,5.547,0L50.003,61.176z"></path></g></svg>
        </div>
      </div>
      <div className={'lightbox-nav'}>
        <div className={'btn'} onClick={(e) => { onSelectIndex(selectedIndex - 1) }} >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg>
        </div>
        <div className={'btn'} onClick={(e) => { onSelectIndex(selectedIndex + 1) }} >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg>
        </div>
      </div>
    </div>
  </div >
}

export default WebglPlayer;